import IMask from 'imask';

const ui = (msgid, ...args) => {
  const text = String(msgid ?? '');
  if (!text) return '';
  const bag = typeof window !== 'undefined' ? window.hskiI18n?.msg : null;
  let out = (bag && typeof bag[text] === 'string' && bag[text]) || text;
  args.forEach((arg) => {
    out = out.replace('%s', String(arg ?? ''));
  });
  return out;
};

const DATE_PATTERN = 'd.m.Y';

const parsePolishDate = (value) => {
  if (!value) return null;
  const parts = value.split('.');
  if (parts.length !== 3) return null;

  const day = Number(parts[0]);
  const month = Number(parts[1]);
  const year = Number(parts[2]);

  if (!day || !month || !year || parts[2].length !== 4) return null;

  const date = new Date(year, month - 1, day);
  const isRealDate = date.getFullYear() === year
    && date.getMonth() === month - 1
    && date.getDate() === day;

  return isRealDate ? date : null;
};

export const createPolishDateMask = (input) => {
  const mask = IMask(input, {
    mask: Date,
    pattern: DATE_PATTERN,
    lazy: false,
    autofix: true,
    blocks: {
      d: {
        mask: IMask.MaskedRange,
        from: 1,
        to: 31,
        maxLength: 2,
      },
      m: {
        mask: IMask.MaskedRange,
        from: 1,
        to: 12,
        maxLength: 2,
      },
      Y: {
        mask: IMask.MaskedRange,
        from: 1900,
        to: new Date().getFullYear(),
        maxLength: 4,
      },
    },
    format: (date) => {
      if (!date) return '';
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      return `${day}.${month}.${date.getFullYear()}`;
    },
    parse: (str) => parsePolishDate(str),
  });

  return mask;
};

export const validatePolishDateMask = (mask, options = {}) => {
  const {
    required = true,
    maxDate = new Date(),
    minDate = null,
    fieldLabel = 'Data',
  } = options;

  const value = mask.value?.trim() || '';
  const label = ui(fieldLabel);

  if (!value || !mask.masked.isComplete) {
    return required
      ? { valid: false, message: ui('%s: uzupełnij datę w formacie DD.MM.RRRR', label) }
      : { valid: true, message: '' };
  }

  const date = parsePolishDate(value);
  if (!date) {
    return { valid: false, message: ui('%s: podaj poprawną datę', label) };
  }

  if (date > maxDate) {
    return { valid: false, message: ui('%s: data nie może być z przyszłości', label) };
  }

  if (minDate && date < minDate) {
    return {
      valid: false,
      message: options.minDateMessage || ui('%s: data jest zbyt odległa', label),
    };
  }

  return { valid: true, message: '', date };
};

export const destroyPolishDateMask = (mask) => {
  mask?.destroy?.();
};
